export const isLegacyEasyAzonEmbedData = (p) => 'identifier' in p &&
    typeof p.identifier === 'string' &&
    'tag' in p &&
    typeof p.tag === 'string' &&
    'retrievedData' in p &&
    typeof p.retrievedData === 'object';
export const isEasyAzonEmbedData = (p) => !isLegacyEasyAzonEmbedData(p) && 'retrievedData' in p && typeof p.retrievedData === 'object';
//# sourceMappingURL=guards.js.map